import { DEFAULT_CATEGORY } from 'Pods/Shared/GalleryFilters/constants'

export const DEFAULT_IMAGE_GALLERY_FILTERS = {
  searchQuery: '',
  category: DEFAULT_CATEGORY,
}

// Generator output ratios (Figma "Aspect ratio" selector). Values are width / height.
export const ASPECT_RATIOS = {
  '1:1': 1,
  '2:3': 2 / 3,
  '3:2': 3 / 2,
  '9:16': 9 / 16,
  '16:9': 16 / 9,
}

export const iconSize = { height: '14px', width: '14px' }
